import React from 'react';
import { Box, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useNavigate } from 'react-router';
import { getAllServices } from 'store/ServiceAction';
import { IconBrandWhatsapp } from '@tabler/icons';

export default function ProtectedRoute({ component }) {
    const dispatch = useDispatch();
    // check for authentication
    const { isAuthenticated, isLoading } = useSelector((state) => state.auth);

    React.useEffect(() => {
        // get services if is authenticated;
        if (isAuthenticated) {
            dispatch(getAllServices());
        }
    }, []);

    if (!isAuthenticated) {
        return <Navigate to={'/login'} />;
    }

    return <>{component}</>;
}
